module.exports = __webpack_public_path__ + "static/media/ic_refresh.b37d3a2a.svg";